export interface ISort {
    field?: any;
    order?: number | 1 | -1;
}

export const SORT_VAL: any = {
    '1': 'asc',
    '-1': 'desc',
};
